import { render, staticRenderFns } from "./TextEditBox.vue?vue&type=template&id=6cd3eb11&scoped=true&"
import script from "./TextEditBox.vue?vue&type=script&lang=ts&"
export * from "./TextEditBox.vue?vue&type=script&lang=ts&"
import style0 from "./TextEditBox.vue?vue&type=style&index=0&id=6cd3eb11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3eb11",
  null
  
)

export default component.exports